import { CounterColour } from '../../MathFactsGenerator/Constants.ts';

/**
 * The events a probability question can ask about (ADR 0108 §2), as data, so
 * the generator counts them and the three languages only word them.
 */

/** One spinner: a given number, even or odd, greater or less than a number, or not a given number. */
export type SpinnerEvent =
    | { kind: 'number' | 'not' | 'greater' | 'less'; n: number }
    | { kind: 'even' | 'odd' };

/** A bag of counters: a colour, not a colour, or one colour or another. */
export type BagEvent =
    | { kind: 'colour' | 'not'; colour: CounterColour }
    | { kind: 'either'; colours: [CounterColour, CounterColour] };

/** Two spinners: a number on each (left, right), two even numbers, or the same number on both. */
export type PairEvent =
    | { kind: 'both'; left: number; right: number }
    | { kind: 'bothEven' }
    | { kind: 'same' };

/** A short stable name for an event, which is what tells two problems apart. */
export function eventName(event: SpinnerEvent | BagEvent | PairEvent): string {
    if ('n' in event) return `${event.kind}:${event.n}`;
    if ('colour' in event) return `${event.kind}:${event.colour}`;
    if ('colours' in event) return `${event.kind}:${event.colours.join('')}`;
    if ('left' in event) return `${event.kind}:${event.left}:${event.right}`;
    return event.kind;
}
